import axios from 'axios'
import {MessageBox, Message} from 'element-ui'
import store from '@/store'
import {getToken} from '@/utils/auth'
import {getItemWithExpiry, setItemWithExpiry} from "@/store/localstoragewithexpire";

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 8000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        let token = getItemWithExpiry("token");
        if (token) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers['Authorization'] = token
        }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
        if (res.foruicode == '403' || res.for == '401') {
            // to re-login
            MessageBox.confirm('登录已过期,请重新登录', '确认退出', {
                confirmButtonText: '重新登陆',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                //localStorage.setItem("isLogin", 0)
                setItemWithExpiry("isLogin",0)
                //location.reload()
            })
            // toekn过期处理
            localStorage.removeItem('token')
            return Promise.reject(new Error(res.message || 'Error'))
        } else if (res.code == '500') {
            // Message({
            //     message: res.msg,
            //     type: 'error',
            //     duration: 3 * 1000
            // })
            return res;
        } else {
            return res;
        }
        //return res;
        // // if the custom code is not 20000, it is judged as an error.
        // if (res.code !== 200) {
        //   if (res.code == 100401) {
        //     Message({
        //       message: res.message || 'Error',
        //       type: 'error',
        //       duration: 5 * 1000
        //     })
        //
        //   } else {
        //     Message({
        //       message: res.message || 'Error',
        //       type: 'error',
        //       duration: 5 * 1000
        //     })
        //     return Promise.reject(new Error(res.message || 'Error'))
        //   }
        // } else {
        //   return res
        // }
    },
    error => {
        console.log('err' + error) // for debug
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service
